import script from "./AIStyleTransfer.vue?vue&type=script&setup=true&lang=ts"
export * from "./AIStyleTransfer.vue?vue&type=script&setup=true&lang=ts"

import "./AIStyleTransfer.vue?vue&type=style&index=0&id=2d94a15b&scoped=true&lang=less"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d94a15b"]])

export default __exports__